
// file Route & run app adminPanel
import routing from './reports.route';
import run from './reports.run';

// controllers & services module Reports
import reportStudentController from './report-student/reportStudentController';
import { listFilter } from '../../components/list-filter'

export default angular.module('app.reports', [])
  .config(routing)
  .controller('reportStudentController', reportStudentController)
  .component('listFilter',listFilter)
  .run(run)
  .constant("reports", [{

    "title": "Reportes",
    "icon":"mdi-account-card-details mdi-light",
    "subMenu":[  
      {  
        "title":"Reporte Estudiante",
        "icon":"mdi-account-circle",
        "url":"app.reportStudent"
      },
	//   {  
    //     "title":"Reporte Docente",
        // "url":"app.olderNursery"
    //   },
	]
}])
.name;


// WEBPACK FOOTER //
// ./src/app/reports/index.js